import { render, staticRenderFns } from "./shopingCar.vue?vue&type=template&id=061e192f&"
import script from "./shopingCar.vue?vue&type=script&lang=js&"
export * from "./shopingCar.vue?vue&type=script&lang=js&"
import style0 from "./shopingCar.vue?vue&type=style&index=0&id=061e192f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports